import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import cmsAdminLogo from "../../assets/images/cmsAdminLogo.png";
import { Button, Container, CssBaseline, withStyles } from "@material-ui/core";
import { deleteCompanyUserAccount } from "../../services/apiservices/users";
import { useToast } from "../../hooks/useToast";
import loginBg from "../../assets/images/pc_loginBg.jpg";
import AuthContext from "../../hooks/authContext";


const styles = (theme) => ({
  pageroot: {
    background: "url(" + loginBg + ") top center no-repeat",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    height: "100vh",
    paddingTop: theme.spacing(2),
  },
  paper: {},
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(4),
  },
  submit: {
    margin: theme.spacing(4, 0, 2),
    background: "#078037",
    color: "#fff",
    "&:hover": {
      background: "#078037",
    },
  },
});

const RemoveCompanyUserAccount = (props) => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const email = searchParams.get("email");
  const navigate = useNavigate();
  const { toast } = useToast();
  const { classes } = props;
  const auth = useContext(AuthContext)

  useEffect(()=>{
    if(auth?.status === true) {
      toast?.({
        title: "Failed to delete",
        description: "Please logout from your current account and try again.",
        variant: "destructive",
      });
      return;
    } else {
      console.log("res")
    }
  })


  const handleDeleteAccount = async () => {
    if (!email) {
      toast?.({
        title: "Failed",
        description: "Invalid link or missing email.",
        variant: "destructive",
      });
      return;
    }

    if(auth?.status === true){
      toast?.({
        title: "Failed to delete",
        description: "Please logout from your current account and try again.",
        variant: "destructive",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await deleteCompanyUserAccount(email);
      console.log("res", res)

      if (res?.status) {
        setDeleted(true);
        toast?.({
          title: "Success",
          description: "Account deleted successfully.",
        });
      } else {
        toast?.({
          title: "Failed",
          description: "Error deleting your account.",
          variant: "destructive",
        });
      }
    } catch (err) {
      console.error(err);
      toast?.({
        title: "Failed",
        description: "Error deleting your account.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoToLogin = () => {
    navigate("/login");
  };


   if (!email) {
    return (
      <div>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div
           className={`${classes.paper} loginwrap sectionBox text-center`}
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "40px 35px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
              marginTop: "100px",
              textAlign: "center",
            }}
          >
            <img
              src={cmsAdminLogo}
              className="cmslogo mb-24"
              alt="ProTeams Logo"
              style={{
                height: "60px",
                marginBottom: "30px",
              }}
            />

            <h1
              style={{
                fontWeight: 600,
                color: "#333",
                marginBottom: "1rem",
                fontSize: "1.25rem",
              }}
            >
              Invalid or Expired Link
            </h1>

            <p
              style={{
                color: "#666",
                marginBottom: "1.5rem",
                lineHeight: 1.6,
              }}
            >
              This account removal link is invalid or has expired. <br />
              Please check your email for a valid link or contact support.
            </p>

            <Button
              onClick={handleGoToLogin}
              style={{
                width: "100%",
                backgroundColor: "#2980ba",
                color: "#fff",
                fontWeight: 600,
                border: "none",
                borderRadius: "8px",
                padding: "10px 0",
                cursor: "pointer",
                transition: "background-color 0.2s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#206694")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#2980ba")
              }
            >
              Go to Login
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div>
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div
        style={{
          minHeight: "100vh",
          background: "#f0fdf4",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <img
          src={cmsAdminLogo}
          alt="ProTeams Logo"
          style={{
            height: "80px",
            marginBottom: "30px",
          }}
        />

        <div
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "40px",
            boxShadow: "0 4px 15px rgba(0, 128, 0, 0.2)",
            textAlign: "center",
            maxWidth: "400px",
            width: "100%",
          }}
        >
          {!deleted ? (
            <>
              <h1
                style={{
                  fontWeight: 600,
                  color: "#065f46",
                  marginBottom: "1rem",
                  fontSize: "1.25rem",
                }}
              >
                Confirm Account Deletion
              </h1>

              <p
                style={{
                  color: "#666",
                  marginBottom: "1.5rem",
                  lineHeight: 1.6,
                }}
              >
                Are you sure you want to permanently delete your account associated with
                <br />
                <strong>{email || ""}</strong>?
              </p>

              <Button
                onClick={handleDeleteAccount}
                disabled={loading}
                fullWidth
                style={{
                  backgroundColor: loading ? "#9ca3af" : "#dc2626",
                  color: "#fff",
                  fontWeight: 600,
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 0",
                  cursor: loading ? "not-allowed" : "pointer",
                  boxShadow: "0 4px 10px rgba(220, 38, 38, 0.3)",
                  transition: "background-color 0.2s ease",
                }}
                onMouseOver={(e) => {
                  if (!loading) e.currentTarget.style.backgroundColor = "#b91c1c";
                }}
                onMouseOut={(e) => {
                  if (!loading) e.currentTarget.style.backgroundColor = "#dc2626";
                }}
              >
                {loading ? "Deleting..." : "Delete My Account"}
              </Button>
            </>
          ) : (
            <>
              <h1
                style={{
                  fontWeight: 600,
                  color: "#16a34a",
                  marginBottom: "1rem",
                  fontSize: "1.25rem",
                }}
              >
                Account Deleted Successfully
              </h1>

              <p
                style={{
                  color: "#666",
                  marginBottom: "1.5rem",
                  lineHeight: 1.6,
                }}
              >
                Your account and associated data have been permanently removed.
                <br />
                Thank you for using <strong>ProTeams</strong>.
              </p>

              <Button
                onClick={handleGoToLogin}
                fullWidth
                style={{
                  backgroundColor: "#2980ba",
                  color: "#fff",
                  fontWeight: 600,
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 0",
                  cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(41,128,186,0.3)",
                  transition: "background-color 0.2s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#206694")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#2980ba")
                }
              >
                Go to Login
              </Button>
            </>
          )}
        </div>
      </div>
    </Container>
  </div>
  );
};

export default withStyles(styles, { withTheme: true })(RemoveCompanyUserAccount);
